import React from 'react';
import { Navbar, Image } from 'react-bootstrap'; 
import scbLogo from '../../resources/images/scb.png';
import './Header.css';
import User from '../user/User';
import { Link } from 'react-router-dom'; 

const Header = (props) => {
    return (
        <Navbar className="justify-content-between header">          
            <Navbar.Brand>
                {props.user ?
                <Link to="/">
                    <Image className="scb-logo" src={scbLogo} alt="SCB Logo"/>
                </Link>
                :
                <Image className="scb-logo" src={scbLogo} alt="SCB Logo"/>
                }
            </Navbar.Brand>
            {props.user &&
                <Navbar.Brand>
                    <User user={props.user} onLogOut={props.onLogOut}/>
                </Navbar.Brand>
            }
        </Navbar> 
    );
}

export default Header;